import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import * as ChatEffects from './state/chat.effects';
import { AI_CHAT_FEATURE_KEY, reducer } from './state/chat.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(AI_CHAT_FEATURE_KEY, reducer),
    EffectsModule.forFeature([ChatEffects]),
  ],
})
export class AiChatDataAccessModule {}
